import React from "react";

export default function RegistrationHeader({
  activeTab,
  setActiveTab,
}: {
  activeTab: string;
  setActiveTab: (tab: string) => void;
}) {
  const handleTabClick = (tab: string) => {
    setActiveTab(tab);
  };

  return (
    <div className={Classname.container}>
      <div className={Classname.profile}>
        <div className={Classname.bold}>Company Profile</div>
        <div className={Classname.supplier}>{/* Optional Supplier ID */}</div>
      </div>

      <div className={Classname.tabContainer}>
        <div
          className={`${Classname.tab} ${
            activeTab === "companyDetails" ? Classname.activeTab : ""
          }`}
          onClick={() => handleTabClick("companyDetails")}
        >
          Company Details
        </div>
        <div
          className={`${Classname.tab} ${
            activeTab === "legalRequirements" ? Classname.activeTab : ""
          }`}
          onClick={() => handleTabClick("legalRequirements")}
        >
          Legal Requirements
        </div>
      </div>
    </div>
  );
}

const Classname = {
  container: "flex flex-col gap-3 p-2 pt-10 lg:p-2",
  profile: "flex justify-between mt-2",
  bold: "font-bold text-2xl mt-2",
  supplier: "flex gap-4",
  tabContainer: "flex gap-10 cursor-pointer mt-2 border-b border-gray-300 mb-7",
  tab: "text-black pb-2 cursor-pointer text-xl",
  activeTab: "text-blue-600 font-semibold border-b-2 border-blue-600 pb-2",
};
